import { React, useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setQuery,
  fetchSearchResults,
  clearSearch,
} from "../../features/search/searchSlice";
import './SideAndSearchbar.css';
import { io } from "socket.io-client";
import config from "../../config"; 
import axios from "axios";
// import { logout } from "../../features/auth/authSlice";

const SideAndSearchbar = () => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const query = useSelector((state) => state.search.query);
  const [inputValue, setInputValue] = useState(query);
  const isAdmin = localStorage.getItem("role") === "admin";
  const isUser = localStorage.getItem("role") === "user";
  const [isOpen, setIsOpen] = useState("");
  const [isMobileOpen, setIsMobileOpen] = useState("");

  const currentWidth = window.innerWidth;
  

  const toggleDrawerDesktop = () => { 
    setIsOpen(!isOpen);
  };

  const toggleDrawerMobile = ()=>{
setIsMobileOpen((prevState) => !prevState);
setIsOpen((prevState) => !prevState);
  }

 

  const handleLogout = async () => {
    try {
      console.log("Logging out...");
      const token = localStorage.getItem("token");

      await axios.post(
        "/api/logout",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      localStorage.removeItem("token");

      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

   const [notificationCount, setNotificationCount] = useState(0);

   useEffect(() => {
     const socket = io(config.socketUrl); 

     socket.on("notificationCount", (count) => {
       setNotificationCount(count);
     });

     return () => {
       socket.disconnect(); 
     };
   }, []);

   const location = useLocation();
   const [activeLink, setActiveLink] = useState(location.pathname);

   useEffect(() => {
     setActiveLink(location.pathname);
   }, [location.pathname]);

  return (
    <>
      <nav
        className={`pcoded-navbar menupos-fixed menu-light brand-blue ${
          isOpen ? "mob-open" : ""
        } ${isOpen ? "navbar-collapsed" : ""}`}
      >
        <div className="navbar-wrapper">
          <div className="navbar-brand header-logo">
            <a href="index.html" className="b-brand">
              <img
                src="../assets/images/logo-image.png"
                alt="Logo"
                className="logo images"
                style={{ width: "150px", height: "auto" }}
              />
              <img
                src="../assets/images/logo-icon.svg"
                alt="Logo Icon"
                className="logo-thumb images"
              />
            </a>
            <a
              className="mobile-menu"
              id="mobile-collapse"
              href="#!"
              onClick={toggleDrawerDesktop}
            >
              <span />
            </a>
          </div>
          <div
            className="navbar-content navbar-content overflow-auto"
            style={{
              maxHeight: "100vh",
            }}
          >
            <ul className="nav pcoded-inner-navbar">
              <li className="nav-item pcoded-menu-caption">
                <label>Navigation</label>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/dashboard" ? "active" : ""
                }`}
              >
                <Link to="/dashboard" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-home" />
                  </span>
                  <span className="pcoded-mtext">Dashboard</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/productlist" ? "active" : ""
                }`}
              >
                <Link to="/productlist" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-boxes" />
                  </span>
                  <span className="pcoded-mtext">Products</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/addproduct" ? "active" : ""
                }`}
              >
                <Link to="/addproduct" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-plus-square" />
                  </span>
                  <span className="pcoded-mtext">Add Product</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/categorieslist" ? "active" : ""
                }`}
              >
                <Link to="/categorieslist" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-th-list" />
                  </span>
                  <span className="pcoded-mtext">Categories</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/addcategory" ? "active" : ""
                }`}
              >
                <Link to="/addcategory" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-plus" />
                  </span>
                  <span className="pcoded-mtext">Add Category</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/brandslist" ? "active" : ""
                }`}
              >
                <Link to="/brandslist" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-tags" />
                  </span>
                  <span className="pcoded-mtext">Brands</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/addbrand" ? "active" : ""
                }`}
              >
                <Link to="/addbrand" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-plus-circle" />
                  </span>
                  <span className="pcoded-mtext">Add Brand</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/orderstable" ? "active" : ""
                }`}
              >
                <Link to="/orderstable" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-box-open" />
                  </span>
                  <span className="pcoded-mtext">Orders</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/userslist" ? "active" : ""
                }`}
              >
                <Link to="/userslist" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-users" />
                  </span>
                  <span className="pcoded-mtext">Users</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/adduser" ? "active" : ""
                }`}
              >
                <Link to="/adduser" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-user-plus" />
                  </span>
                  <span className="pcoded-mtext">Add User</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/couponslist" ? "active" : ""
                }`}
              >
                <Link to="/couponslist" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-box" />
                  </span>
                  <span className="pcoded-mtext">Coupons</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/addcoupon" ? "active" : ""
                }`}
              >
                <Link to="/addcoupon" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-ticket-alt" />
                  </span>
                  <span className="pcoded-mtext">Add Coupon</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/reviews" ? "active" : ""
                }`}
              >
                <Link to="/reviews" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-star" />
                  </span>
                  <span className="pcoded-mtext">Reviews</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/addreview" ? "active" : ""
                }`}
              >
                <Link to="/addreview" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-pen" />
                  </span>
                  <span className="pcoded-mtext">Add Review</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/paymentlist" ? "active" : ""
                }`}
              >
                <Link to="/paymentlist" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-credit-card" />
                  </span>
                  <span className="pcoded-mtext">Payments</span>
                </Link>
              </li>
              <li
                className={`nav-item ${
                  activeLink === "/settinglist" ? "active" : ""
                }`}
              >
                <Link to="/settinglist" className="nav-link">
                  <span className="pcoded-micon">
                    <i className="fas fa-cog" />
                  </span>
                  <span className="pcoded-mtext">Settings</span>
                </Link>
              </li>
              <li className={`nav-item ${activeLink === "/" ? "active" : ""}`}>
                <Link to="/" className="nav-link" onClick={handleLogout}>
                  <span className="pcoded-micon">
                    <i className="fas fa-sign-out-alt" />
                  </span>
                  <span className="pcoded-mtext">Log Out</span>
                </Link>
              </li>
            </ul>

            {/* Upgrade section */}
            <div className="card text-center">
              <div className="card-block">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-hidden="true"
                >
                  ×
                </button>
                <i className="feather icon-sunset f-40" />
                <h6 className="mt-3">Upgrade to pro</h6>
                <p>Upgrade to get full themes and 30min support</p>
                <a
                  href="https://codedthemes.com/item/flash-able-bootstrap-admin-template/"
                  target="_blank"
                  className="btn btn-gradient-primary btn-sm text-white m-0"
                >
                  Upgrade
                </a>
              </div>
            </div>

            {/* Scrollbar Rails */}
            <div className="ps__rail-x" style={{ left: 0, bottom: 0 }}>
              <div
                className="ps__thumb-x"
                tabIndex={0}
                style={{ left: 0, width: 0 }}
              />
            </div>
            <div
              className="ps__rail-y"
              style={{ top: 0, height: "100%", right: 0 }}
            >
              <div
                className="ps__thumb-y"
                tabIndex={0}
                style={{ top: 0, height: 43 }}
              />
            </div>
          </div>
        </div>
      </nav>

      {/* <!-- [ Header ] start --> */}
      <header className="navbar pcoded-header navbar-expand-lg navbar-light headerpos-fixed">
        <div className="m-header">
          <a
            className={`mobile-menu ${isMobileOpen ? "on" : ""}`}
            id="mobile-collapse1"
            href="#!"
            onClick={toggleDrawerMobile}
          >
            <span></span>
          </a>
          <a href="index.html" className="b-brand">
            <img
              src="../assets/images/logo.svg"
              alt=""
              className="logo images"
            />
            <img
              src="../assets/images/logo-icon.svg"
              alt=""
              className="logo-thumb images"
            />
          </a>
        </div>
        <a className="mobile-menu" id="mobile-header" href="#!">
          <i className="feather icon-more-horizontal"></i>
        </a>
        <div className="collapse navbar-collapse">
          <a href="#!" className="mob-toggler"></a>
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <div className="main-search open">
                <div className="input-group">
                  <input
                    type="text"
                    id="m-search"
                    className="form-control"
                    placeholder="Search . . ."
                  />
                  <a href="#!" className="input-group-append search-close">
                    <i className="feather icon-x input-group-text"></i>
                  </a>
                  <span className="input-group-append search-btn btn btn-primary">
                    <i className="feather icon-search input-group-text"></i>
                  </span>
                </div>
              </div>
            </li>
          </ul>
          <ul className="navbar-nav ml-auto">
            <li>
              <div className="dropdown">
                <a className="dropdown-toggle" href="#" data-toggle="dropdown">
                  <i className="icon feather icon-bell"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right notification">
                  <div className="noti-head">
                    <h6 className="d-inline-block m-b-0">Notifications</h6>
                    <div className="float-right">
                      <a href="#!" className="m-r-10">
                        mark as read
                      </a>
                      <a href="#!">clear all</a>
                    </div>
                  </div>
                  <ul className="noti-body">
                    <li className="n-title">
                      <p className="m-b-0">NEW</p>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img
                          className="img-radius"
                          src="../assets/images/user/avatar-1.jpg"
                          alt="Generic placeholder image"
                        />
                        <div className="media-body">
                          <p>
                            <strong>John Doe</strong>
                            <span className="n-time text-muted">
                              <i className="icon feather icon-clock m-r-10"></i>
                              5 min
                            </span>
                          </p>
                          <p>New ticket Added</p>
                        </div>
                      </div>
                    </li>
                    <li className="n-title">
                      <p className="m-b-0">EARLIER</p>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img
                          className="img-radius"
                          src="../assets/images/user/avatar-2.jpg"
                          alt="Generic placeholder image"
                        />
                        <div className="media-body">
                          <p>
                            <strong>Joseph William</strong>
                            <span className="n-time text-muted">
                              <i className="icon feather icon-clock m-r-10"></i>
                              10 min
                            </span>
                          </p>
                          <p>Prchace New Theme and make payment</p>
                        </div>
                      </div>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img
                          className="img-radius"
                          src="../assets/images/user/avatar-3.jpg"
                          alt="Generic placeholder image"
                        />
                        <div className="media-body">
                          <p>
                            <strong>Sara Soudein</strong>
                            <span className="n-time text-muted">
                              <i className="icon feather icon-clock m-r-10"></i>
                              12 min
                            </span>
                          </p>
                          <p>currently login</p>
                        </div>
                      </div>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img
                          className="img-radius"
                          src="../assets/images/user/avatar-1.jpg"
                          alt="Generic placeholder image"
                        />
                        <div className="media-body">
                          <p>
                            <strong>Joseph William</strong>
                            <span className="n-time text-muted">
                              <i className="icon feather icon-clock m-r-10"></i>
                              30 min
                            </span>
                          </p>
                          <p>Prchace New Theme and make payment</p>
                        </div>
                      </div>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img
                          className="img-radius"
                          src="../assets/images/user/avatar-3.jpg"
                          alt="Generic placeholder image"
                        />
                        <div className="media-body">
                          <p>
                            <strong>Sara Soudein</strong>
                            <span className="n-time text-muted">
                              <i className="icon feather icon-clock m-r-10"></i>
                              1 hour
                            </span>
                          </p>
                          <p>currently login</p>
                        </div>
                      </div>
                    </li>
                    <li className="notification">
                      <div className="media">
                        <img
                          className="img-radius"
                          src="../assets/images/user/avatar-1.jpg"
                          alt="Generic placeholder image"
                        />
                        <div className="media-body">
                          <p>
                            <strong>Joseph William</strong>
                            <span className="n-time text-muted">
                              <i className="icon feather icon-clock m-r-10"></i>
                              2 hour
                            </span>
                          </p>
                          <p>Prchace New Theme and make payment</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div className="noti-footer">
                    <a href="#!">show all</a>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="dropdown drp-user">
                <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                  <i className="icon feather icon-settings"></i>
                </a>
                <div className="dropdown-menu dropdown-menu-right profile-notification">
                  <div className="pro-head">
                    <img
                      src="../assets/images/user/avatar-1.jpg"
                      className="img-radius"
                      alt="User-Profile-Image"
                    />
                    <span>John Doe</span>
                    <a
                      href="auth-signin.html"
                      className="dud-logout"
                      title="Logout"
                    >
                      <i className="feather icon-log-out"></i>
                    </a>
                  </div>
                  <ul className="pro-body">
                    <li>
                      <a href="#!" className="dropdown-item">
                        <i className="feather icon-settings"></i> Settings
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="dropdown-item">
                        <i className="feather icon-user"></i> Profile
                      </a>
                    </li>
                    <li>
                      <a href="message.html" className="dropdown-item">
                        <i className="feather icon-mail"></i> My Messages
                      </a>
                    </li>
                    <li>
                      <a href="auth-signin.html" className="dropdown-item">
                        <i className="feather icon-lock"></i> Lock Screen
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </header>

      {/* <div
        className={`overlay ${isOpen ? "active" : ""}`}
        onClick={toggleDrawer}
      ></div> */}

      {/* <div className={`drawer ${isOpen ? "open" : ""}`}>
        <ul className="navbar-nav">
          
          {isUser && (
            <>
              <main>
                <div>
                  <li className="nav-item border-bottom ">
                    <Link className="nav-link me-4" to="/landingpage">
                      <i className="fas fa-home mx-2"></i>
                      Home
                    </Link>
                  </li>

                  <li className="nav-item border-bottom">
                    <Link className="nav-link me-4" to="/orderuserlist">
                      <i className="fas fa-box-open mx-2"></i>
                      Orders
                    </Link>
                  </li>
                  <li className="nav-item border-bottom">
                    <Link className="nav-link me-4" to="/wishlist">
                      <i className="fas fa-heart mx-2"></i>
                      Wishlist
                    </Link>
                  </li>
                  <li className="nav-item border-bottom">
                    <Link className="nav-link me-4" to="/couponuserlist">
                      <i className="fas fa-box mx-2"></i>
                      Coupons
                    </Link>
                  </li>
                  <li className="nav-item border-bottom">
                    <Link className="nav-link me-4" to="/orderuserlist">
                      <i className="fas fa-cog mx-2"></i>
                      Settings
                    </Link>
                  </li>
                  <li className="nav-item border-bottom">
                    <Link className="nav-link me-4" to="/myProfileForm">
                      <i className="fas fa-user mx-2"></i>
                      My Profile
                    </Link>
                  </li>
                  <li className="nav-item">
                    {!isAuthenticated ? (
                      <Link className="nav-link" to="/login">
                        <i className="fas fa-sign-out-alt mx-2 "></i>
                        Logout
                      </Link>
                    ) : (
                      <a className="nav-link" href="#" onClick={handleLogout}>
                        <i className="fas fa-sign-in-alt mx-2  "></i>
                        Login
                      </a>
                    )}
                  </li>
                </div>
              </main>
            </>
          )}
          
          {isAdmin && (
            <>
              <main>
                <div
                  className="nav-scroll-container"
                  style={{ maxHeight: "600px", overflowY: "auto" }}
                >
                  <ul className="nav flex-column">
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/">
                        <i className="fas fa-tachometer-alt mx-2"></i>
                        Dashobard
                      </Link>
                    </li>

                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/ordersTable">
                        <i className="fas fa-box-open mx-2"></i>
                        Orders
                      </Link>
                    </li>

                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/productlist">
                        <i className="fas fa-boxes mx-2"></i>
                        Products
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/addproduct">
                        <i className="fas fa-plus-square mx-2"></i>
                        Add Product
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/brandslist">
                        <i className="fas fa-tags mx-2"></i>
                        Brands
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/addbrand">
                        <i className="fas fa-plus-circle mx-2"></i>
                        Add Brand
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/categorieslist">
                        <i className="fas fa-th-list mx-2"></i>
                        Categories
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/addcategory">
                        <i className="fas fa-plus mx-2"></i>
                        Add Category
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/userslist">
                        <i className="fas fa-users mx-2"></i>
                        Users
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/adduser">
                        <i className="fas fa-user-plus mx-2"></i>
                        Add User
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/couponslist">
                        <i className="fas fa-box mx-2"></i>
                        Coupons
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/addcoupon">
                        <i className="fas fa-ticket-alt mx-2"></i>
                        Add Coupons
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/review">
                        <i className="fas fa-star mx-2"></i>
                        Reviews
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/addReview">
                        <i className="fas fa-pen mx-2"></i>
                        Add Review
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/addReview">
                        <i className="fas fa-credit-card mx-2"></i>
                        Payment
                      </Link>
                    </li>
                    <li className="nav-item border-bottom">
                      <Link className="nav-link" to="/addReview">
                        <i className="fas fa-cog mx-2"></i>
                        Settings
                      </Link>
                    </li>
                    <li className="nav-item ">
                      <a className="nav-link" href="#" onClick={handleLogout}>
                        <i className="fas fa-sign-out-alt mx-2"></i>
                        Logout
                      </a>
                    </li>
                  </ul>
                </div>
              </main>
            </>
          )}
        </ul>
      </div> */}
    </>
  );
};

export default SideAndSearchbar;
